import { useEffect } from "react";
import { useTrelloPowerUpContext } from "../../trello-iframe/context";

export const _PostAuthorization = ({ token }) => {
  const { trelloIFrame } = useTrelloPowerUpContext();

  useEffect(() => {
    // https://developer.atlassian.com/cloud/trello/guides/power-ups/authentication/
    let authorize;

    try {
      if (window.opener && typeof window.opener.authorize === "function") {
        authorize = window.opener.authorize;
      }
    } catch (e) {
      // Security settings are preventing this, fall back to local storage. See if/else below.
    }

    if (authorize) {
      console.log("Post auth authorize()");
      authorize(token);
    } else {
      trelloIFrame.set("organization", "private", "token", token).catch((e) => {
        return trelloIFrame.set("board", "private", "token", token);
      });
    }

    setTimeout(function () {
      window.close();
    }, 1000);
  });

  return <div>Authorizing...</div>;
};
